import React from "react";
import AppBar from "@material-ui/core/AppBar";

import ModelTable from "../components/ModelTable";

export default function Browser(props) {
  const { client } = props;

  return (
    <React.Fragment>
      <AppBar position="static" color="default" elevation={0} />
      <ModelTable client={client} />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/sections/models/subsections/Browser.js